import Api from './api.service';

export default {
  get: () => Api.get(`terms?user_type=1`),
};
